import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import articleSlice from "./slices/articleSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    article: articleSlice,
  },
});
